import styled from '@emotion/styled';
import { Content } from '~/shared/components/Modal/styled';

export const PDPMediaContainer = styled.div(({ theme }) => ({
    width: '100%',
    marginBottom: theme.space[6],
    [`${Content}`]: {
        backgroundColor: theme.colors.productImageBackround,
    },
}));
